import React from 'react';
export function ProblemSection() {
  return <section className="py-10 md:py-14 px-4 bg-black text-white border-y-4 border-red-600" data-id="element-163">
      <div className="max-w-3xl mx-auto" data-id="element-164">
        <div className="space-y-6 text-base md:text-lg" data-id="element-165">
          <div className="text-center mb-10" data-id="element-166">
            <h2 className="text-2xl md:text-3xl font-black text-yellow-400 mb-4" data-id="element-167">
              Si sos mamá o papá, dejame hacerte una pregunta honesta
            </h2>
            <p className="font-bold text-xl md:text-2xl leading-relaxed" data-id="element-168">
              ¿Sentís que querés pasar más tiempo con tus hijos…
              <br data-id="element-169" />
              <span className="text-red-400" data-id="element-170">
                pero cuando llega el momento no sabés qué hacer juntos?
              </span>
            </p>
          </div>

          <div className="space-y-3 text-gray-300 max-w-2xl mx-auto" data-id="element-171">
            <p data-id="element-172">No porque no los ames.</p>
            <p data-id="element-173">No porque no quieras estar.</p>
            <p className="font-bold text-white" data-id="element-174">
              Sino porque la rutina, el trabajo, el cansancio y las pantallas se
              comen todo el tiempo.
            </p>
            <p data-id="element-175">Y cuando te das cuenta…</p>
            <p className="font-bold text-red-400 text-xl md:text-2xl" data-id="element-176">
              otro día se fue. Y no hicieron nada juntos.
            </p>
            <p className="text-yellow-400 italic text-sm md:text-base mt-3" data-id="element-177">
              Los hijos no esperan. Crecen. Y las etapas que no viviste con
              ellos… no vuelven.
            </p>
          </div>

          <div className="bg-gray-900 p-5 rounded-xl border border-gray-700 mt-10 shadow-lg" data-id="element-178">
            <h3 className="text-xl md:text-2xl font-black text-white mb-4 border-b border-gray-700 pb-3" data-id="element-179">
              El problema que nadie dice en voz alta
            </h3>
            <div className="space-y-3 text-gray-300" data-id="element-180">
              <p data-id="element-181">
                Muchos padres comparten el mismo techo…{' '}
                <span className="text-yellow-400 font-bold" data-id="element-182">
                  pero no comparten momentos reales.
                </span>
              </p>
              <p data-id="element-183">Cada uno está en su mundo. En su celular. En su rutina.</p>
              <p data-id="element-184">
                Querés hacer algo especial con tus hijos, pero no sabés qué
                proponer.
              </p>
              <p data-id="element-185">Los días pasan. Las semanas vuelan.</p>
              <p className="font-bold text-white" data-id="element-186">
                Y los hijos crecen en silencio.
              </p>
              <p className="italic text-lg md:text-xl text-white font-medium border-l-4 border-red-500 pl-4 my-4" data-id="element-187">
                "Podría estar haciendo más… si tuviera una forma simple de
                hacerlo."
              </p>
            </div>
          </div>

          <div className="text-center mt-10 space-y-3" data-id="element-188">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-189">
              No es falta de amor.
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-190">
              Es falta de un plan.
            </p>

            <div className="text-left max-w-xl mx-auto mt-6 space-y-3 text-gray-300" data-id="element-191">
              <p data-id="element-192">
                Los padres quieren conectar con sus hijos. Pero muchas veces:
              </p>
              <ul className="space-y-2 font-medium text-white" data-id="element-193">
                <li className="flex items-center gap-2" data-id="element-194">
                  ❌ no saben qué actividades hacer
                </li>
                <li className="flex items-center gap-2" data-id="element-195">
                  ❌ no tienen tiempo para planificar
                </li>
                <li className="flex items-center gap-2" data-id="element-196">
                  ❌ no quieren pasar horas organizando algo que dura 10 minutos
                </li>
              </ul>
              <p className="text-lg md:text-xl font-bold text-red-400 mt-5 text-center" data-id="element-197">
                Y por eso termina ganando la pantalla. Otra vez.
              </p>
              <p className="text-center text-yellow-400 font-bold italic mt-3 text-sm md:text-base" data-id="element-198">
                Los recuerdos familiares no se improvisan. Se crean.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}